/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class s extends r{constructor(r,s,t,e){super(r,"mat4",1,(t,o,m)=>t.setUniformMatrices4fv(r,s(o,m),e),t)}}export{s as Matrix4sPassUniform};
